const allrefundvoucher = { data: [], loading: true, cache: {} };

export const GetAllRefund = (state = allrefundvoucher, action) => {
  switch (action.type) {
    case "get_allrefund":
      return {
        ...state,
        data: action.payload,
        loading: action.loading ?? false,
        cache: action.cacheKey
          ? { ...state.cache, [action.cacheKey]: action.payload }
          : state.cache,
      };
    case "clear_refund_cache":
      return {
        ...state,
        cache: {},
      };
    default:
      return state;
  }
};
